import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { AppBar, SvgIcon, Switch } from '../../../Molecules';

import styles from './CreateMemoryGameContentEditTemplate.module.css';
import { TextArea } from '../../../Molecules/TextArea';

type TextInputProps = {
  value: string;
  placeHolder?: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
};

type CreateMemoryGameContentEditTemplateProps = {
  type: 'Question' | 'Answer' | undefined;
  language: string;
  isUseTts: boolean;
  gameContent: TextInputProps;
  textLength: number;
  maxTextLength: number;
  isNextDisabled: boolean;
  isExceedLimit: boolean;
  onClickLanguage: () => void;
  onSwitchTts: () => void;
  onClickAutoTranslate: () => void;
  onClickAudioBar: () => void;
  onClickOK: () => void;
  onClickBack: () => void;
};

export const CreateMemoryGameContentEditTemplate = (
  props: CreateMemoryGameContentEditTemplateProps,
) => {
  const {
    type,
    language,
    isUseTts,
    gameContent,
    textLength,
    maxTextLength,
    isNextDisabled,
    isExceedLimit,
    onClickLanguage,
    onSwitchTts,
    onClickAutoTranslate,
    onClickAudioBar,
    onClickOK,
    onClickBack,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.createMemoryContentEdit}>
      <AppBar title={type ? t(type) : ''} onClickBack={onClickBack} />
      <div className={styles.container}>
        {/* <p className={styles.title}>{t(title)}</p> */}

        <div className={styles.buttonContainer}>
          <div className={styles.languageSelector} onClick={onClickLanguage}>
            <SvgIcon
              name={SVGIconType.LanguageA}
              width={28}
              height={28}
              stroke={'white'}
            />
            <span className={styles.language}>{t(language)}</span>
            <SvgIcon
              name={SVGIconType.Triangle}
              width={20}
              height={20}
              stroke={'white'}
              fill={'white'}
            />
          </div>

          <div className={styles.textToSpeech}>
            <SvgIcon
              name={SVGIconType.TTS}
              width={28}
              height={28}
              stroke={'white'}
            />
            <span>{t('+Text-to-Speech')}</span>
            <div className={styles.switch}>
              <Switch checked={isUseTts} onChange={onSwitchTts} />
            </div>
          </div>
        </div>

        {isUseTts ? (
          <div className={styles.audioBar} onClick={onClickAudioBar}>
            <SvgIcon
              name={SVGIconType.PlayerPlay}
              width={24}
              height={24}
              fill={'#cccccc'}
            />
            <div className={styles.audioTrack} />
          </div>
        ) : null}

        {type === 'Question' ? (
          <div className={styles.cellHeader}>
            <button
              className={styles.translateButton}
              onClick={onClickAutoTranslate}
            >
              {t('Auto-translate Answer')}
            </button>
          </div>
        ) : null}

        <div className={styles.textSection}>
          <TextArea
            textEntryClassName={styles.textEntry}
            textEntryAreaClassName={styles.textEntryArea}
            value={gameContent.value}
            onChange={gameContent.onChange}
            isAutoResize={true}
            placeholder={
              gameContent.placeHolder
                ? t(gameContent.placeHolder)
                : t('Enter text')
            }
          />
          {/* <div className={styles.textEntry}>
            <textarea
              className={styles.textEntryArea}
              value={gameContent.value}
              onChange={gameContent.onChange}
              placeholder={
                gameContent.placeHolder
                  ? t(gameContent.placeHolder)
                  : t('Enter text')
              }
            />
          </div> */}
          <span
            className={styles.charLimit}
            style={{ color: isExceedLimit ? '#D95141' : '#808080' }}
          >
            {t('{count} words (max. {maxCount})', {
              count: textLength,
              maxCount: maxTextLength,
            })}
          </span>
        </div>
      </div>
      <div className={styles.bottomBar}>
        <button
          className={styles.okButton}
          onClick={onClickOK}
          disabled={isNextDisabled}
        >
          <span className={styles.okText}>{t('OK')}</span>
          {isNextDisabled ? <div className={styles.blackShadow} /> : null}
        </button>
      </div>
    </div>
  );
};
